const InitMain = () => {
  const groupProducts = document.querySelector('.group-products');
  const productsItemTitle = document.querySelector('.products--item-title');
  productsItemTitle.innerHTML = groupProducts.innerHTML;
};
export default InitMain;
